import Footer from "@app/components/Footer";
import Header from "@app/components/Header";
import ScrollToTop from "@components/ScrollToTop/ScrollToTop";
import { useTheme } from "@src/app/hooks/useTheme";

type CommonRenderProps = {
  children: React.ReactNode;
};

export default function CommonRender({ children }: CommonRenderProps) {
  const theme = useTheme();

  return (
    <div
      className={
        "bg-background-default dark:bg-background-primary-on-dark min-h-screen"
      }
    >
      <Header theme={theme} />

      {children}

      <ScrollToTop />

      <Footer theme={theme} />
    </div>
  );
}
